import { useLang } from "@/lib/lang";
import { IMG } from "@/lib/constants";
import { BadgeCheck, Award } from "lucide-react";

const members = [
  {
    name: "Manthan Sharma",
    role_en: "Founder · Lead Dietitian",
    role_hi: "फ़ाउंडर · लीड डाइटिशियन",
    bio_en: "Qualified dietitian with 10+ years of hands-on experience helping Indians — at home and abroad — reset their body around real food, not fad plans.",
    bio_hi: "10+ साल का अनुभव। पंजाबी NRI और लोकल क्लाइंट्स को असली खाने से रीसेट करने में विशेषज्ञता।",
    image: IMG.manthan,
    badge_en: "Qualified Dietitian",
    badge_hi: "प्रमाणित डाइटिशियन",
    imgClass: "object-cover",
  },
  {
    name: "Ankita",
    role_en: "Clinical Dietitian",
    role_hi: "क्लिनिकल डाइटिशियन",
    bio_en: "Your DietWalaa Dietitian — Ankita leads weekly client follow-ups, plan revisions and the day-to-day WhatsApp support that makes DietWalaa feel personal. She's the reason our clients don't drop off.",
    bio_hi: "आपकी DietWalaa डाइटिशियन — अंकिता क्लाइंट फ़ॉलो-अप्स, प्लान बदलाव और रोज़ के WhatsApp सपोर्ट संभालती हैं। यही वजह है कि हमारे क्लाइंट्स कभी बीच में नहीं छोड़ते।",
    image: IMG.ankita,
    badge_en: "Clinical Dietitian",
    badge_hi: "क्लिनिकल डाइटिशियन",
    imgClass: "object-cover",
  },
];

export default function Team() {
  const { t, lang } = useLang();
  return (
    <section id="team" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="section-eyebrow">{lang === "hi" ? "टीम" : t.about.eyebrow}</div>
          <h2 className="mt-3 font-display text-4xl md:text-5xl leading-tight" style={{ color: "var(--primary)" }}>
            {lang === "hi" ? "आपके पीछे खड़ी टीम" : "Meet the team behind your plan"}
          </h2>
          <p className="mt-4 text-lg max-w-2xl" style={{ color: "var(--text-secondary)" }}>
            {lang === "hi"
              ? "एक क्वालिफाइड डाइटिशियन और एक ट्रेंड टीम — जो सच में हर हफ़्ते फॉलो-अप करती है।"
              : "A qualified dietitian and a hands-on client success team — who actually check in on you every week."}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-8 lg:gap-12">
          {members.map((m, i) => (
            <div key={m.name} data-testid={`team-member-${i}`} className="relative pb-8">
              <div className="rounded-[32px] overflow-hidden shadow-xl border-4 h-[420px] md:h-[520px]" style={{ borderColor: i === 0 ? "var(--yellow)" : "var(--primary)" }}>
                <img
                  src={m.image}
                  alt={m.name}
                  className={`w-full h-full ${m.imgClass}`}
                  style={{ objectPosition: i === 0 ? "50% 30%" : "50% 30%" }}
                />
              </div>
              <div className="mt-6 px-1">
                <div className="text-xs uppercase tracking-widest font-bold" style={{ color: "var(--red)" }}>
                  {lang === "hi" ? m.role_hi : m.role_en}
                </div>
                <h3 className="mt-2 font-display text-3xl md:text-4xl" style={{ color: "var(--primary)" }}>{m.name}</h3>
                <div className="mt-2 inline-flex items-center gap-1.5 text-xs font-bold px-2.5 py-1 rounded-full" style={{ background: "var(--yellow)", color: "var(--primary)" }}>
                  {i === 0 ? <BadgeCheck size={12} /> : <Award size={12} />}
                  {lang === "hi" ? m.badge_hi : m.badge_en}
                </div>
                <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                  {lang === "hi" ? m.bio_hi : m.bio_en}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
